module.exports = kolibriGlobal.heartbeat;